import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryTabs = ({ activeCategory, onCategoryChange, unreadCounts, currentLanguage }) => {
  const translations = {
    en: {
      all: 'All',
      payment: 'Payment Alerts',
      offers: 'Offer Updates',
      flights: 'Flight Delays',
      disputes: 'Disputes',
      admin: 'Admin Messages'
    },
    ko: {
      all: '전체',
      payment: '결제 알림',
      offers: '제안 업데이트',
      flights: '항공편 지연',
      disputes: '분쟁',
      admin: '관리자 메시지'
    }
  };

  const t = translations?.[currentLanguage];

  const categories = [
    { id: 'all', label: t?.all, icon: 'Bell', color: 'text-primary' },
    { id: 'payment', label: t?.payment, icon: 'CreditCard', color: 'text-green-600' },
    { id: 'offers', label: t?.offers, icon: 'Tag', color: 'text-blue-600' },
    { id: 'flights', label: t?.flights, icon: 'Plane', color: 'text-orange-600' },
    { id: 'disputes', label: t?.disputes, icon: 'AlertTriangle', color: 'text-red-600' },
    { id: 'admin', label: t?.admin, icon: 'Shield', color: 'text-purple-600' }
  ];

  return (
    <div className="mb-6 overflow-x-auto">
      <div className="flex gap-2 min-w-max pb-2">
        {categories?.map((category) => {
          const unreadCount = unreadCounts?.[category?.id] || 0;
          const isActive = activeCategory === category?.id;

          return (
            <button
              key={category?.id}
              onClick={() => onCategoryChange(category?.id)}
              className={`relative flex items-center gap-2 px-4 py-3 rounded-lg transition-all ${
                isActive
                  ? 'bg-primary text-primary-foreground shadow-md'
                  : 'bg-card hover:bg-muted text-foreground border border-border'
              }`}
            >
              <Icon
                name={category?.icon}
                size={18}
                className={isActive ? '' : category?.color}
              />
              <span className="text-sm font-medium whitespace-nowrap">{category?.label}</span>
              {unreadCount > 0 && (
                <span
                  className={`ml-1 px-2 py-0.5 rounded-full text-xs font-bold ${
                    isActive
                      ? 'bg-primary-foreground text-primary'
                      : 'bg-accent text-accent-foreground'
                  }`}
                >
                  {unreadCount > 99 ? '99+' : unreadCount}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryTabs;